var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 13L9.70005 15.9C9.88338 16.0834 9.97505 16.3167 9.97505 16.6C9.97505 16.8834 9.88338 17.1167 9.70005 17.3C9.51672 17.4834 9.28338 17.575 9.00005 17.575C8.71672 17.575 8.48338 17.4834 8.30005 17.3L3.70005 12.7C3.60005 12.6 3.52922 12.4917 3.48755 12.375C3.44588 12.2584 3.42505 12.1334 3.42505 12C3.42505 11.8667 3.44588 11.7417 3.48755 11.625C3.52922 11.5084 3.60005 11.4 3.70005 11.3L8.30005 6.70005C8.48338 6.51672 8.71672 6.42505 9.00005 6.42505C9.28338 6.42505 9.51672 6.51672 9.70005 6.70005C9.88338 6.88338 9.97505 7.11672 9.97505 7.40005C9.97505 7.68338 9.88338 7.91672 9.70005 8.10005L6.80005 11H20C20.2834 11 20.5209 11.0959 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2834 20.9042 12.5209 20.7125 12.7125C20.5209 12.9042 20.2834 13 20 13H6.80005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWest);
export default __webpack_public_path__ + "static/media/West.9bbc1283fcbed479e7126c37cf83420a.svg";
export { ForwardRef as ReactComponent };